/**
 * Created by A_BU on 19/3/25.
 */
import axios from "../../utils/axios";


export function recycleList(query) {
    return axios({
        url: "/admin/recycle/recycle/recycleList",
        method: "get",
        params: query
    });
}

export function recycleRecovery(data) {
    return axios({
        url: "/admin/recycle/recycle/recycleRecovery",
        method: "post",
        data: data
    });
}

